import React from 'react';

const DEFAULT_STATS = [
  { icon: '👨‍🎓', label: 'طالب نشط', value: '10000+' },
  { icon: '👨‍🏫', label: 'مدرس متخصص', value: '500+' },
  { icon: '📚', label: 'كورس', value: '1000+' },
  { icon: '⭐', label: 'معدل الرضا', value: '4.8/5' }
];

const StatsSection = ({ stats }) => {
  // جذر الحل: تطبيع البيانات (Normalization)
  const safeStats = Array.isArray(stats) && stats.length > 0
    ? stats
    : DEFAULT_STATS;

  return (
    <div className="bg-white py-12 sm:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {safeStats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-4xl sm:text-5xl font-bold text-primary-600 mb-2">
                {stat.icon && (
                  <span className="text-3xl block mb-2">{stat.icon}</span>
                )}
                {stat.value}
              </div>
              <p className="text-gray-600 font-medium">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatsSection;
